import React from 'react';

export const debounce = (func: Function, wait: number, immediate: boolean) => {
  let timeout: number | undefined;
  return () => {
    const context = this;
    const args = { func, wait, immediate };
    const later = () => {
      timeout = undefined;
      if (!immediate) {
        func.apply(context, args);
      }
    };
    const callNow = immediate && !timeout;
    window.clearTimeout(timeout);
    timeout = window.setTimeout(later, wait);
    if (callNow) {
      func.apply(context, args);
    }
  };
};

export const formatNumber = (num: number | undefined) => {
  // TODO: Evaluate our usage of this function and update to use Number.isNaN
  // (which returns false for {}'s and []'s which is a problem)
  // eslint-disable-next-line no-restricted-globals
  if (!num || isNaN(num)) {
    return '';
  }
  const n = num.toString();
  if (n.length < 4) {
    return n;
  }

  return n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const mergeRefs =
  <T>(...refs: React.ForwardedRef<T>[]) =>
  (element: T) => {
    refs.forEach((ref) => {
      if (!ref) {
        return;
      }

      if (typeof ref === 'function') {
        ref(element);
      } else {
        // eslint-disable-next-line no-param-reassign
        ref.current = element;
      }
    });
  };
